import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { isDecisionDevBypass } from '../../config/portalMode';
import { PORTAL_ROLE_LABEL } from '../../config/portalNav';
import MacroStrip from './components/MacroStrip';
import CopilotPanel from './components/CopilotPanel';
import './decision-theme.css';

const NAV = [
  { to: '/', label: '总览' },
  { to: '/macro', label: '宏观环境' },
  { to: '/product', label: '产品分析' },
  { to: '/portfolio', label: '我的持仓' },
  { to: '/config', label: '策略配置' },
  { to: '/ai-settings', label: '模型设置' }
];

export default function DecisionLayout({ user, onLogout }) {
  const navigate = useNavigate();

  function logout() {
    onLogout();
    navigate('/login', { replace: true });
  }

  return (
    <div className="decision-shell">
      <aside className="decision-sidebar">
        <div className="decision-brand">OLDOX DECISION</div>
        {isDecisionDevBypass ? (
          <div className="bond-chip" style={{ fontSize: 11 }}>本地免登录预览</div>
        ) : null}
        {user ? (
          <div className="decision-user">
            <div>{user.username}</div>
            <div>{PORTAL_ROLE_LABEL[user.portalRole] || user.portalRole}</div>
          </div>
        ) : null}
        <nav className="decision-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) => (isActive ? 'decision-nav-item active' : 'decision-nav-item')}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <button type="button" className="decision-btn ghost" onClick={logout}>
          退出登录
        </button>
      </aside>
      <main className="decision-main">
        <MacroStrip />
        <Outlet />
        <p className="decision-footer-note">规则型辅助分析，非投资建议。说明书与运作报告仅使用人工审核发布的数据。</p>
      </main>
      <CopilotPanel />
    </div>
  );
}
